import { Helmet } from "react-helmet";
import Day1BranchWise from "../components/statscharts/Day1BranchWise";
import Day2CompanyWise from "../components/statscharts/Day2CompanyWise";
import Day2BranchWise from "../components/statscharts/Day2BranchWise";
import Day1CompanyWise from "../components/statscharts/Day1CompanyWise";
const Stats = () => {
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Statistics | Placementor</title>
        <link
          rel="icon"
          type="image/png"
          href="https://github.com/MejarKumar/All-Company-Logo/blob/main/favicon-32x32.png?raw=true"
        />
        <meta name="theme-color" content="#064420" />
      </Helmet>
      <div
        style={{
          textAlign: "center",
          margin: "2rem auto",
          padding: "1rem",
          fontFamily: "sans-serif",
          color: "rgba(238, 79, 152, 1)",
          // maxWidth: "1000px",
        }}
      >
        <h1
          style={{
            fontSize: "clamp(1.5rem, 2.5vw, 3rem)",
            marginBottom: "1.5rem",
          }}
        >
          On Campus Placements 2024
        </h1>
        <Day1CompanyWise/>
        <Day1BranchWise/>
        <Day2CompanyWise/>
        <Day2BranchWise/>
      </div>
    </div>
  );
}

export default Stats;